import { Component } from '@angular/core';

@Component({
  selector: 'views-autenticazione-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {

}
